const isObj = require('lodash.get');

export const getUserActivationErrors = (state) => isObj(state, 'userActivationErrors', false);
export const getUserActivationSuccess = (state) => isObj(state, 'userActivationSuccess', false);
export const getResetPasswordSuccess = (state) => isObj(state, 'resetPasswordSuccess', false);
export const getResetPasswordError = (state) => isObj(state, 'resetPasswordError', false);
